<template>
    <v-container fluid grid-list-md class="buy-ip">
        <div class="headline ma-3 text-color-vip bold">
            Mua Proxy Riêng
        </div>
        <v-layout row wrap>
            <v-flex md12>
                <div class="card card-default">
                    <div class="card-header">
                        <h3 class="card-title">
                            <i class="mdi mdi-shield-half-full"></i>
                            Mua Proxy v6
                        </h3>
                    </div>
                    <div class="card-body">
                        <v-form ref="form_fb_post_process">
                            <v-layout align-center row class="pa-0">
                                <v-flex md2>
                                    <label class="text-color">Tên Proxyv6</label>
                                </v-flex>
                                <v-flex md10>
                                    <v-text-field
                                            solo
                                            v-model="proxyName"
                                            placeholder="Nhập tên proxy muốn lưu để ghi nhớ"
                                            required
                                    ></v-text-field>
                                </v-flex>
                            </v-layout>

                            <!--videoRef-->
                            <v-layout align-center row v-if="videoId">
                                <v-flex md2>
                                </v-flex>
                                <v-flex md10>
                                    <div class="v-sheet theme--light explain">
                                        <a href="#videoRef">
                                            <span class="blue_text label-highlight">Video hướng dẫn tạo job</span>
                                        </a>
                                    </div>
                                </v-flex>
                            </v-layout>

                            <v-layout align-center row>
                                <v-flex md2>
                                    <label class="text-color">Quốc gia</label>
                                </v-flex>
                                <v-flex md10 pt-6>
                                    <v-select
                                            solo
                                            :items="nations"
                                            v-model="nation"
                                            item-text="text"
                                            item-value="value"
                                            @change="resetPrice"
                                    ></v-select>
                                </v-flex>
                            </v-layout>

                            <v-layout align-center row>
                                <v-flex md2>
                                    <label class="text-color">Thời gian thuê</label>
                                </v-flex>
                                <v-flex md10 pt-6>
                                    <v-select
                                            solo
                                            :items="noDays"
                                            v-model="noDay"
                                            item-text="text"
                                            item-value="value"
                                            @change="resetPrice"
                                    ></v-select>
                                </v-flex>
                            </v-layout>
                            <v-layout align-center row>
                                <v-flex md2>
                                </v-flex>
                                <v-flex md10 pt-6>
                                    <ul>
                                        <li>Proxy riêng để chạy BOT hạn chế checkpoint hơn.</li>
                                        <li>Nếu cảm thấy quốc gia nào ổn định thì chọn.</li>
                                        <li>Tìm hiểu kỹ về Proxyv6 trước khi thanh toán.</li>
                                        <li>Nên gia hạn Proxy trước lúc hết hạn để tránh việc bị hủy Proxy.</li>
                                        <li>Chúng tôi không hoàn lại Proxy đã Thanh Toán.</li>
                                    </ul>
                                </v-flex>
                            </v-layout>
                        </v-form>

                        <v-layout align-center row>
                            <v-flex md12>
                                <v-card style="background-color: #fff">
                                    <v-card-title>
                                        <div class="div-total">
                                            <h5>Tổng : <span class="font-weight-bold">
                                            <span class="text-primary">{{ totalCoin }}</span></span>
                                                <small>coin</small>
                                            </h5>
                                            <h6 class="mb-0">Giá Proxyv6 của bạn là <span class="text-primary">{{ price }}</span>
                                                <small>coin</small>/ngày</h6>
                                        </div>
                                    </v-card-title>
                                </v-card>
                            </v-flex>
                        </v-layout>

                        <v-layout align-center row>
                            <v-flex md12>
                                <v-btn width="100%" height="50px" style="background-color: #007bff"
                                       class="white--text payment"
                                       @click="saveProcess">
                                    <i class="mdi mdi-cart"></i>
                                    THANH TOÁN
                                </v-btn>
                            </v-flex>
                        </v-layout>
                    </div>
                </div>
            </v-flex>
            <v-flex xs12>
                <div class="card card-default">
                    <div class="card-header">
                        <h3 class="card-title">Danh Sách Proxyv6</h3>
                    </div>
                    <div class="card-body table-responsive">
                        <v-card-title>
                            <v-spacer></v-spacer>
                            <v-text-field
                                    v-model="search"
                                    outlined
                                    append-icon="search"
                                    label="Tìm kiếm"
                                    hide-details
                            ></v-text-field>
                        </v-card-title>
                        <v-data-table
                                :headers="headers"
                                :items="desserts"
                                :options.sync="options"
                                :server-items-length="totalDesserts"
                                :loading="loading"
                                class="elevation-1"
                        >
                            <template v-slot:item.post_id="{item}">
                                <v-layout row>
                                    <a class="a-post-link" :href="item.post_link" target="_blank">{{ item.post_id }}</a>
                                </v-layout>
                            </template>
                            <template v-slot:item.seeding_type="{item}">
                                <v-layout row>
                                    <span>{{ listSeedingApi[item.seeding_type-1].title }}</span>
                                </v-layout>
                            </template>
                            <template v-slot:item.total_coin="{item}">
                                <span>{{ item.total_coin }}</span>
                            </template>

                            <template v-slot:item.running="{item}">
                                <span>{{ item.num_seeding_gain - item.num_start_seeding }}</span>
                            </template>

                            <template v-slot:item.price="{ item }">
                                <span>{{ item.fix_coin_job }}</span>
                            </template>

                            <!--action-->
                            <template v-slot:item.action="{item}">
                                <v-layout row>
                                    <div class="col-12 pa-1">
                                        <v-btn depressed small color="primary" @click="openDialogExtendDate(item)">
                                            Gia hạn
                                        </v-btn>
                                    </div>
                                </v-layout>
                            </template>
                        </v-data-table>
                    </div>
                </div>
            </v-flex>
        </v-layout>

        <!--        dialog extend day-->
        <v-dialog v-model="dialogExtendDate"
                  max-width="800px"
        >
            <v-card elevation="4">
                <v-card-title>
                    <span class="headline">Gia hạn ip</span>
                </v-card-title>
                <v-card-text>
                    <v-container fluid>
                        <v-form
                                ref="form_date_hire"
                                v-model="checkFormCookie"
                                lazy-validation
                        >
                            <v-flex md2>
                                <label class="text-color">Số ngày thuê</label>
                            </v-flex>
                            <v-text-field
                                    solo
                                    v-model="dateHire"
                                    type="number"
                                    required
                                    :rules="dayHireRule"
                                    placeholder="Nhập số ngày thuê"
                            ></v-text-field>
                        </v-form>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1"
                           text
                           @click="dialogExtendDate = false"
                    >
                        Close
                    </v-btn>
                    <v-btn color="blue darken-1"
                           text
                           @click="extendDate()"
                    >
                        Update
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!--video youtube-->
        <v-layout align-center row v-if="videoId" id="videoRef">
            <v-flex md12>
                <div class="col-sm-12 mb-n3">
                    <h3 class="text-color">HƯỚNG DẪN SỬ DỤNG</h3>
                </div>
                <div class="col-sm-12 mb-n3">
                    <youtube :video-id="videoId" ref="youtube"
                             @buffering="playing"
                             @paused="paused"
                             @ended="paused"
                             @playing="playing"
                             width="100%" height="650px">
                    </youtube>
                </div>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
  import {
    BOT_INTERACTION_GET_LIST_PROXY,
    BOT_INTERACTION_BUY_PROXY,
    BOT_INTERACTION_GET_LIST_PROXY_ORDER,
    BOT_INTERACTION_EXTEND_DATE_PROXY,
    FB_POST_GET_LIST_SEEDING
  } from '~/store/actions.type'
  import {
    COMMON_SET_LOADING
  } from '../../store/mutations.type'
  import Swal from 'sweetalert2'

  export default {
    data () {
      return {
        // form
        checkFormCookie: false,

        proxyName: '',

        dateHire: 1,

        // dialog
        dialogExtendDate: false,

        nations: [
          { value: 'au', text: 'Australia', coin: 100 },
          { value: 'ru', text: 'Russia', coin: 100 },
          { value: 'de', text: 'Germany', coin: 100 },
          { value: 'ua', text: 'Ukraine', coin: 100 },
          { value: 'us', text: 'United States', coin: 100 },
          { value: 'sg', text: 'United Kingdom', coin: 100 },
          { value: 'gb', text: 'Australia', coin: 100 },
          { value: 'fr', text: 'France', coin: 100 },
          { value: 'nl', text: 'Netherlands', coin: 100 },
        ],
        nation: 1,

        noDays: [
          { value: 3, text: '3 Ngày' },
          { value: 7, text: '7 Ngày' },
          { value: 14, text: '14 Ngày' },
          { value: 30, text: '30 Ngày' },
          { value: 60, text: '60 Ngày' },
        ],
        // noDay: {value: 3, text: '3 Ngày'},
        noDay: 3,

        price: 800,
        totalCoin: '',

        search: '',
        totalDesserts: 0,
        desserts: [],
        loading: true,
        options: {},
        headers: [
          { text: '#', value: 'id', align: 'center' },
          { text: 'Ngày thuê', value: 'created_at', align: 'center', width: '150' },
          { text: 'Name Proxy', value: 'name', align: 'center' },
          { text: 'Quốc gia', value: 'region', align: 'center' },
          // { text: 'IPv6', value: '', align: 'center' },
          { text: 'Thời hạn', value: 'expired_at', align: 'center', width: '150px' },
          { text: 'Hành động', value: 'action', align: 'center', width: '300px' }
        ],
        // id | date | proxy_name | nation | ipv6 | proxy | port | username | password | period | action

        // rules
        dayHireRule: [
          v => !!v || 'Trường này là bắt buộc',
          v => v >= 1 || 'Bạn phải gia hạn ít nhất 1 ngày',
        ],

          videoId: '',
          videoStatus: true,
      }
    },
    created () {
      this.customDataFromApi()
    },

    watch: {
      nation () {
        this.price = this.nations.filter(item => item.value === this.nation)[0].coin
      },

      options: {
        handler () {
          this.initTable()
        },
        deep: true,
      },

      search () {
        this.options.page = 1
        this.initTable()
      }
    },

    mounted () {
     this.initTable()
    },
    methods: {
      initTable() {
        this.getDataFromApi()
          .then(data => {
            this.desserts = data.items
            this.totalDesserts = data.total
          })
      },

      async customDataFromApi () {
        let data = await this.$store.dispatch(BOT_INTERACTION_GET_LIST_PROXY)
        this.nations = data.nations
        this.noDays = data['no_days']
          if (this.nations[0] !== undefined) {
              this.nation = this.nations[0].value;
              this.price = this.nations.filter(item => item.value === this.nation)[0].coin;
          }
        this.initDefault();


          this.listSeedingApi = await this.$store.dispatch(FB_POST_GET_LIST_SEEDING);
          for (let i = 0; i < this.listSeedingApi.length; i++) {
              if (this.listSeedingApi[i].type === 'bot-proxy') {
                  if (this.listSeedingApi[i].video) {
                      let videoId = this.youtube_parser(this.listSeedingApi[i].video);
                      if (videoId) {
                          this.videoId = videoId;
                      }
                  }
              }
          }
      },

      initDefault () {
        this.calculate()
      },

      resetPrice () {
        this.calculate()
      },

      async calculate () {
        this.totalCoin = this.noDay * this.price
      },

      getParams () {
        return {
          days: this.noDay,
          region_id: this.nation,
          total_coin: this.totalCoin,
          name: this.proxyName
        }
      },

      validateForm () {
        let valid = true
        if (this.proxyName.trim() === '') {
          return { check: false, message: 'Vui lòng nhập tên proxy muốn lưu để ghi nhớ' }
        }
        return { check: valid, message: '' }
      },

      async saveProcess () {
        this.calculate()
        let validateForm = this.validateForm()
        if (validateForm.check) {
          try {
            Swal.fire({
              title: 'Xác nhận',
              text: 'Bạn có chắc chắn muốn mua ip ',
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Đồng ý!',
              cancelButtonText: 'Không'
            }).then((result) => {
              if (result.value) {
                this.overlay = true
                this.saveProcessApi()
                this.options.page = 1
              }
            })
          } catch (error) {
            console.log(error)
          }
        } else {
          Swal.fire(
            validateForm.message,
            '...',
            'error'
          )
        }
      },

      async saveProcessApi () {
        await this.$store.dispatch(BOT_INTERACTION_BUY_PROXY, this.getParams())
        this.initTable()
      },

      async getDataFromApi () {
        this.loading = true

        const { sortBy, sortDesc, page } = this.options

        let pageNumber = page.page || this.options.page
        let rowsPerPage = page.itemsPerPage || this.options.itemsPerPage

        let data = await this.$store.dispatch(BOT_INTERACTION_GET_LIST_PROXY_ORDER, {
          'search': this.search,
          'page': pageNumber,
          'rowsPerPage': rowsPerPage
        })

        let items = data['orders']
        const total = data.total

        if (sortBy.length === 1 && sortDesc.length === 1) {
          items = items.sort((a, b) => {
            const sortA = a[sortBy[0]]
            const sortB = b[sortBy[0]]

            if (sortDesc[0]) {
              if (sortA < sortB) return 1
              if (sortA > sortB) return -1
              return 0
            } else {
              if (sortA < sortB) return -1
              if (sortA > sortB) return 1
              return 0
            }
          })
        }
        this.loading = false
        return { items, total }
      },

      openDialogExtendDate(order) {
        this.currentOrder = order;
        this.dialogExtendDate = true
      },

      async extendDate () {
        if (this.$refs['form_date_hire'].validate()) {
          this.$store.commit(COMMON_SET_LOADING, true)
          let status = await this.$store.dispatch(BOT_INTERACTION_EXTEND_DATE_PROXY, {
            'id': this.currentOrder.id,
            'date_hire': this.dateHire
          })

          this.$store.commit(COMMON_SET_LOADING, false)
          if (status) {
            this.dialogExtendDate = false
            this.getDataFromApi()
            location.reload()
          }
        }
      },

        playing() {
            this.videoStatus = false;
        },
        paused() {
            this.videoStatus = true;
        },
        youtube_parser(url) {
            let regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
            let match = url.match(regExp);
            return (match && match[7].length == 11) ? match[7] : false;
        }
    },
  }
</script>

<style lang="scss" scoped>
    @import "../../scss/main";

    .v-content .v-content__wrap {
        background-color: #f4f6f9;
    }

    .flex {
        padding-right: 7.5px !important;
        padding-left: 7.5px !important;
    }

    .btn {
        display: inline-block;
        font-weight: 400;
        color: #212529;
        text-align: center;
        vertical-align: middle;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        background-color: transparent;
        border: 1px solid transparent;
        padding: .375rem .75rem;
        font-size: 1rem;
        line-height: 1.5;
        border-radius: .25rem;
        transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;
    }

    .card {
        box-shadow: 0 0 1px rgba(0, 0, 0, .125), 0 1px 3px rgba(0, 0, 0, .2);
        margin-bottom: 1rem;
        min-width: 0;
        background-color: #fff;
        background-clip: border-box;
        border: 0 solid rgba(0, 0, 0, .125);
        border-radius: .25rem;
    }

    .card-title i.mdi {
        font-size: 20px;
    }

    .card-title {
        float: left;
        font-size: 1.1rem;
        font-weight: 400;
        margin: 0;
    }

    .card-body {
        flex: 1 1 auto;
        padding: 1.25rem;
    }

    .text-color {
        color: #000;
    }

    .v-text-field__details {
        display: none;
    }

    form.v-form {
        margin-bottom: 2rem;
    }

    .buy-ip {
        .div-total {
            width: 100%;
            color: #000;
            text-align: center;

            h5 {
                font-size: 1.2rem;
                margin-bottom: 0.5rem;
                font-family: inherit;
                font-weight: 400;
                line-height: 1.2;
                color: inherit;
            }

            h6 {
                font-family: inherit;
                font-weight: 400;
                line-height: 1.2;
                color: inherit;
                font-size: 0.9rem;
            }

            .font-weight-bold {
                font-weight: 700 !important;
            }

            .text-primary {
                color: #007bff !important;
            }

            .small, small {
                font-size: 80%;
                font-weight: 400;
            }

            .mb-0, .my-0 {
                margin-bottom: 0 !important;
            }
        }
    }

    .v-data-table table {
        border-top: thin solid rgba(0, 0, 0, 0.12);

        tbody tr td:not(.v-data-table__mobile-row),
        thead tr th:not(.v-data-table__mobile-row) {
            border-right: thin solid rgba(0, 0, 0, 0.12);

        }

        thead tr th {
            color: #000 !important;
            padding: .75rem;
            font-size: 15px;
            vertical-align: top;
        }
    }
</style>
